import React from "react";
import { Link } from "react-router-dom";
import BackToTopButton from "../components/BackToTopButton";
import Footer from "../components/Footer";

// Import profile images
import jonProfile from "../images/jonathon-vandergrift.jpg";
import akProfile from "../images/akshay-kumar.jpg";
import jimProfile from "../images/jim-luers.jpg";
import joshProfile from "../images/josh-hissem.jpg";
import andrewProfile from "../images/andrew-videira.jpg";
import jayProfile from "../images/jay-nali.jpg";
import vinceProfile from "../images/vince-greco.jpg";

const testimonials = [
  {
    name: "Jonathon Vandergrift",
    title: "Senior eCommerce Technology Manager at Timex Group",
    dateRelation: "February 2, 2025 - Jonathon managed Chad directly @ Timex Group.",
    image: jonProfile,
    feedback: [
      "I had the pleasure of working with Chad at Timex Group, where he played an integral role as a senior developer on our Salesforce Commerce Cloud platform.  From the very start, it was clear that Chad had a deep understanding of e-commerce technologies, particularly within the SFCC ecosystem, and he quickly became a key contributor to our success.",

      "Throughout our time together, Chad consistently demonstrated strong technical expertise, problem-solving abilities, and an eagerness to innovate.  He was responsible for developing and implementing complex solutions that improved our online shopping experience, optimized workflows, and ensured seamless integration with third-party systems.  His proficiency in Salesforce Commerce Cloud was evident in solutions he produced and his ability to troubleshoot and resolve issues efficiently.",

      "What truly sets Chad apart is his collaborative mindset. Even though he worked remotely, Chad was always fully engaged with the team; bringing a positive attitude and a willingness to do what was necessary to deliver solutions on time.  His communication skills are strong, and he has the ability to explain complex technical concepts in a way that was easy to understand for non-technical stakeholders.",

      "Beyond his technical acumen, Chad is a dedicated and hardworking individual. He consistently displayed a strong work ethic and a passion for learning new technologies, ensuring he kept up with changes in the Salesforce ecosystem.  His contribution to our team was invaluable, and I have no doubt he will continue to excel in any future roles.",

      "I highly recommend Chad to any team looking for a skilled, reliable, and collaborative developer. He would be a tremendous asset to any organization.",
    ],
  },
  {
    name: "Akshay Kumar",
    title: "ENTERPRISE ARCHITECT at Pet Supermarket",
    dateRelation: "November 21, 2024 - Akshay was senior to Chad but did not manage Chad directly @ GNC & Pet Supermarket.",
    image: akProfile,
    feedback: [
		"I had the pleasure of working with Chad Espelage, and I can confidently say he is an exceptional Salesforce Commerce Cloud (SFCC) Front-End Developer. Chad approaches every project he works on with a unique blend of technical know-how, inventiveness, and a user-focused approach.",

		"Chad continuously went above and above during our collaboration by producing front-end solutions that were excellent, responsive, and captivating. His deep knowledge of SFCC allowed him to seamlessly customize storefronts, integrate complex third-party tools, and optimize site performance across all platforms.",

		"In addition to his technical prowess, Chad is an excellent team player. He ensures alignment throughout a project by communicating with both technical and non-technical stakeholders in an effective manner. He is a great asset to any team because of his proactive approach to problem-solving and his capacity to mentor others.",

		"If you're looking for a skilled, innovative, and reliable front-end developer with expertise in Salesforce Commerce Cloud, I highly recommend Chad Espelage. He's not only a talented developer but also a true professional who elevates every team he joins."
    ],
  },
  {
    name: "Jim Luers",
    title: "Director of Web Development",
    dateRelation: "November 1, 2024 - Jim managed Chad directly @ TradeGlobal.",
    image: jimProfile,
    feedback: [
      "I worked with Chad at TradeGlobal and would definitely recommend him for any front end development position using Salesforce Commerce Cloud (SFCC). Chad has strong HTML/CSS/JS skills and understands the SFCC/Demandware platform. He's a hard worker, gets along well with people, and is very helpful. He's also a great guy, good teammate and a pleasure to work with!"
    ],
  },
  {
    name: "Josh Hissem",
    title: "SFCC/SFRA Developer with a focus on UX, UI and Accessibility",
    dateRelation: "November 1, 2024 - Josh managed Chad directly @ LiveArea – The PFS Agency.",
    image: joshProfile,
    feedback: [
      "Chad was a great addition to our Salesforce Commerce Cloud Front End team during his tenure at PFSWeb. Chad's knowledge and skill regarding all aspects of front end development contributed to the success of all projects he was assigned to. Chad's communication skills are absolutely unmatched. Where many developers lack communication, Chad was quick to reach out with updates regarding his project and assignment progress and his professionalism with clients was excellent. Chad would be a great addition to any web development team and given the opportunity, I would proudly work with him again."
    ],
  },
  {
    name: "Andrew Videira",
    title: "Chief Marketing Officer",
    dateRelation: "October 30, 2024 - Andrew managed Chad directly @ Luminess Cosmetics.",
    image: andrewProfile,
    feedback: [
		"I am pleased to recommend Chad, who was an invaluable member of our team for two years as a Salesforce front-end development expert. Chad's attention to detail and commitment to quality set a high standard for our projects.",

		"One of his greatest strengths was his ability to bridge the gap between our marketing, creative, and IT development teams. He consistently delivered projects on time, ensuring that every element was quality checked and executed with excellence. Chad's proactive follow-ups were crucial in maintaining momentum and ensuring that initiatives were carried out effectively.",

		"His agility in navigating quick changes and shifts in strategy, all while maintaining a positive attitude, made him a true team player. Chad was essential to our team's success, enabling us to adapt and deliver projects efficiently and effectively.",

		"I wholeheartedly recommend Chad for any opportunity he pursues; his expertise and collaborative spirit will undoubtedly bring value to any organization."
    ],
  },
  {
    name: "Jay Nali",
    title: "Executive Leader Focused on Generating Sales and Operations Results",
    dateRelation: "October 21, 2024 - Jay was senior to Chad but didn't manage Chad directly @ Luminess Cosmetics.",
    image: jayProfile,
    feedback: [
		"Chad consistently produced outstanding results with a can-do attitude. He continued to develop his skills to align himself to the company and business requirements and was a valued member of our development team."
    ],
  },
  {
    name: "Vince Greco",
    title: "Head of Research",
    dateRelation: "April 2, 2019 - Chad was Vince's client - Recruiter that placed him at Timex.",
    image: vinceProfile,
    feedback: [
      "I truly enjoyed working with Chad. He exemplifies professionalism. His work is thorough, creative and timely. While he is undoubtedly very strong technically, he also a genuinely nice guy who would be a phenomenal additional to any organization."
    ]
  }
];

const TestimonialCard = ({ name, title, dateRelation, image, feedback, children }) => (
  <div className="recommendation container">
    <div className="profile-image">
      <img src={image} alt={`${name} LinkedIn`} />
    </div>
    <div className="content">
      <p className="name">{name}</p>
      <p className="title">{title}</p>
      <p className="date-relation">{dateRelation}</p>
      {feedback.map((para, index) => (
        <p className="feedback" key={index}>{para}</p>
      ))}
      {children}
    </div>
  </div>
);

const TestimonialsPage = () => {
  return (
    <div className="page-container">
      <h1>Testimonials</h1>
      <p>Recommendations from professionals I've worked with.</p>
      <p className="li-link">(received on <Link to="https://www.linkedin.com/in/chad-espelage/" target="_blank">LinkedIn</Link>)</p>
      {testimonials.map((testimonial, index) => (
        <TestimonialCard key={index} {...testimonial} />
      ))}
      <div className="badge-base LI-profile-badge" data-locale="en_US" data-size="medium" data-theme="light" data-type="VERTICAL" data-vanity="chad-espelage" data-version="v1"></div>
      <BackToTopButton />
      <Footer />
    </div>
  );
};

export default TestimonialsPage;
